import { Button, Checkbox, Input } from 'antd';
import React from 'react';

export default null;

const onChangeImg = (changeImage, cell) => () => {
  const input = document.createElement('input');
  input.type = 'file';
  input.style.display = 'none';
  input.onchange = (event) => {
    if (event.target.files.length <= 0) return;
    const file = new FileReader();
    const typeFile = event.target.files[0].type;
    if (typeFile !== 'image/png' && typeFile !== 'image/jpeg') return;
    file.onload = (e) => {
      changeImage(e.target.result, cell.key);
    };
    file.readAsDataURL(event.target.files[0]);
    document.body.removeChild(input);
  };

  document.body.appendChild(input);
  input.click();
};

export function TableImagesConfig(change, changeImage) {
  return [
    {
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
      width: 120,
      fixed: 'left',
    },
    {
      title: 'Высота',
      dataIndex: 'height',
      key: 'height',
      width: 100,
      render: (height, image) => (
        <Input
          type="number"
          value={height}
          style={{ width: 70 }}
          onChange={(e) => change(image.key, e.target.value, 'height')}
        />
      ),
    },
    {
      title: 'Изображение',
      dataIndex: '',
      key: '',
      width: 120,
      render: (cell) => (
        <Button type="primary" onClick={onChangeImg(changeImage, cell)}>Выбрать</Button>
      ),
    },
    {
      title: 'Вырав. по центру',
      dataIndex: 'align',
      key: 'align',
      width: 80,
      render: (align, image) => (
        <Checkbox
          checked={align}
          onChange={(e) => change(image.key, e.target.checked, 'align')}
        />
      ),
    },
    {
      title: 'X',
      dataIndex: 'x',
      key: 'x',
      width: 80,
      render: (x, image) => (
        <Input
          type="number"
          size="small"
          value={x}
          style={{ width: 70 }}
          onChange={(e) => change(image.key, e.target.value, 'x')}
        />
      ),
    },
    {
      title: 'Y',
      dataIndex: 'y',
      key: 'y',
      width: 80,
      render: (y, image) => (
        <Input
          type="number"
          size="small"
          value={y}
          style={{ width: 70 }}
          onChange={(e) => change(image.key, e.target.value, 'y')}
        />
      ),
    },
    {
      title: 'Показать',
      dataIndex: 'show',
      key: 'show',
      width: 90,
      render: (show, image) => (
        <Checkbox
          checked={show}
          onChange={(e) => change(image.key, e.target.checked, 'show')}
        />
      ),
    },
  ];
}
